import React from "react";
import { Modal, Spin, Row } from "antd";
import { Form, ButtonItem, ErrorItem } from "../../../../Components/Items";
import "../cmms.css";

// Contenedor comun de los modales de alta/edicion del CMMS:
// encabezado con titulo y subtitulo, cuerpo gris con secciones en tarjetas
// (DynamicCardForm) y pie fijo con Cancelar / Guardar.
//
// El <Form> vive aqui para que el boton Guardar del pie pueda ser htmlType="submit".
// Etiquetas arriba del campo (layoutForm="vertical"): no se truncan en columnas
// angostas y el mismo formulario funciona en celular.
const ModalFormCMMS = ({
    titulo,
    subtitulo,
    icono,
    visible,
    loading,
    onCancel,
    formRef,
    name,
    onFinish,
    onValuesChange,
    textoGuardar = "Guardar",
    notaPie,
    accionesPie, // botones extra a la izquierda del pie (ej. Cancelar viaje)
    width = 820,
    children,
}) => (
    <Modal
        className="cmms-modal"
        visible={visible}
        onCancel={onCancel}
        width={window.innerWidth > 900 ? width : "96%"}
        footer={null}
        destroyOnClose={false}
        maskClosable={false}
        centered
        title={
            <div className="cmms-modal-titulo">
                {icono}
                <div>
                    <div className="cmms-modal-titulo-texto">{titulo}</div>
                    {subtitulo ? <div className="cmms-modal-subtitulo">{subtitulo}</div> : null}
                </div>
            </div>
        }
    >
        <Spin spinning={!!loading}>
            <Form
                ref={formRef}
                name={name}
                layoutForm="vertical"
                onFinish={onFinish}
                onValuesChange={onValuesChange}
                onFinishFailed={(e) => ErrorItem(e)}
            >
                <div className="cmms-modal-cuerpo">
                    <Row gutter={14}>{children}</Row>
                </div>
                <div className="cmms-modal-pie">
                    {accionesPie ? <span className="cmms-modal-pie-nota">{accionesPie}</span> : null}
                    {notaPie ? <span className="cmms-modal-pie-nota">{notaPie}</span> : null}
                    <ButtonItem type="default" htmlType="button" onClick={onCancel}>
                        Cancelar
                    </ButtonItem>
                    <ButtonItem type="primary" htmlType="submit">
                        {textoGuardar}
                    </ButtonItem>
                </div>
            </Form>
        </Spin>
    </Modal>
);

export default ModalFormCMMS;
